
export default function maxRssi(entry) {
	return Math.max(
		(entry.protocol.radioStatus & 1) === 1 ? entry.radio[0].avgRSSI : -130,
		(entry.protocol.radioStatus & 2) === 2 ? entry.radio[1].avgRSSI : -130
	)
}